/**
 * @Author: Junaid Atari junaid.attari@invozone.dev
 * @Date: 2025-02-18 13:25:45
 */

import React from 'react';

// ui
import {SkeletonBodyText, SkeletonDisplayText} from '@shopify/polaris';

const PageSkeleton: React.FC = () => (
  <>
    <div style={{marginBottom: 10}}>
      <div style={{marginTop: 5}}><SkeletonDisplayText size="extraLarge" maxWidth="30%"/></div>
      <div style={{marginTop: 5}}><SkeletonDisplayText maxWidth="60%" size="small"/></div>
    </div>
    <div style={{marginTop: 15}}>
      <SkeletonBodyText lines={25}/>
    </div>
    <div style={{marginTop: 15}}><SkeletonDisplayText size="large" maxWidth="10%"/></div>
  </>
);

export default PageSkeleton;
